import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/24/solid';
import PropTypes from 'prop-types';

const Navigation = ({ toCurrentMonth, toPrevMonth, toNextMonth, currentMonth, minYear, maxYear }) => {
  const currentYear = currentMonth.getFullYear();
  const currentMonthIndex = currentMonth.getMonth();
  
  // 前の月ボタン：最小年の1月の場合は無効
  const isPrevDisabled = currentYear === minYear && currentMonthIndex === 0;
  
  // 次の月ボタン：最大年の12月の場合は無効
  const isNextDisabled = currentYear === maxYear && currentMonthIndex === 11;

  return (

    <div className="flex items-center gap-2">
      <button
        onClick={toCurrentMonth}
        className="border rounded px-3 sm:px-4 py-2 hover:bg-gray-100 transition-colors text-xs sm:text-sm leading-none">
        今月
      </button>

      <button
        disabled={isPrevDisabled}
        onClick={toPrevMonth}
        className="text-gray-600 disabled:text-gray-300 w-8 h-8 rounded-full hover:bg-gray-100 transition-colors grid place-items-center disabled:hover:bg-transparent"
      >
        <ChevronLeftIcon className="h-5 w-5 sm:h-6 sm:w-6" />
      </button>

      <button
        disabled={isNextDisabled}
        onClick={toNextMonth}
        className="text-gray-600 disabled:text-gray-300 w-8 h-8 rounded-full hover:bg-gray-100 transition-colors grid place-items-center disabled:hover:bg-transparent"
      >
        <ChevronRightIcon className="h-5 w-5 sm:h-6 sm:w-6" />
      </button>
    </div>
  );
};

Navigation.propTypes = {
  toCurrentMonth: PropTypes.func,
  toNextMonth: PropTypes.func,
  toPrevMonth: PropTypes.func,
  currentMonth: PropTypes.instanceOf(Date),
  minYear: PropTypes.number,
  maxYear: PropTypes.number
};

export default Navigation;
